<template>
  <div>
    <breadcrumb :items="breadcrumbs" />
    <v-container fluid>
      <div class="d-flex align-center mb-8 carbon-credit-users-header">
        <h2 class="font-weight-bolder carbon-credit-users-title">{{ $t('carbonCredit.user.title') }}</h2>
        <div class="d-flex align-center flex-nowrap ml-4 mt-6" style="min-width: 0;">
          <!-- <v-select v-model="projectType" :items="projectTypeList" item-text="name" item-value="value"
            class="carbon-credit-filter-select carbon-credit-filter-select-type mr-2" outlined dense :placeholder="$t('carbonCredit.projectType')"
            clearable></v-select> -->
          <v-autocomplete
            v-if="isUserDataReady && isSuperAdmin"
            v-model="organizations"
            :items="safeOrganizationList"
            item-text="name"
            item-value="id"
            class="carbon-credit-filter-select mr-2"
            outlined
            dense
            :placeholder="$t('carbonCredit.user.selectOrganization')"
            @change="filterData"
            clearable
            :filter="filterOrganizations"
          ></v-autocomplete>
          <v-select v-model="projects" :items="safeProjectList" item-text="project_title" item-value="id"
            class="carbon-credit-filter-select carbon-credit-filter-select-project mr-2" outlined dense
            :placeholder="projectType ? $t('carbonCredit.user.selectProject') : $t('carbonCredit.user.selectProjectTypeFirst')"
            @change="filterData" :disabled="!projectType" clearable></v-select>
         
        </div>
        <!-- <v-btn v-if="isUserDataReady && isSuperAdmin" color="primary" dark class="ml-auto" v-bind="attrs" v-on="on" @click="handleRegisterProject">
            {{ $t('carbonCredit.registerProject') }}
          </v-btn> -->
      </div>
      <!-- Data Table Card -->
      <v-card elevation="0" class="px-5 mt-7">
        <v-card-text>
          <v-row style="margin-left: -30px; margin-bottom: 20px; margin-top: 15px;">
            <v-col cols="12">
              <v-data-table :headers="displayTableHeaders" :items="users" :items-per-page="options.limit"
                :footer-props="{ 'items-per-page-options': itemsPerPageOptions }" item-key="id" hide-default-footer
                :loading="loading" :options.sync="options" :server-items-length="totalUsers"
                :loading-text="$t('loadingData')">
                <template v-slot:top>

                  <!-- Filter Summary Cards (same design as UserDetails view-block) -->
                  <v-card elevation="0" class="px-3 mb-3">
                    <div v-if="hasActiveFilters" class="mb-6">
                      <v-row>
                        <v-col cols="12" sm="6" md="3" v-if="projectType">
                          <div class="view-block">
                            <div class="d-flex align-center">
                              <label class="view-label">{{ $t('carbonCredit.projectType') }}</label>
                              <v-tooltip top color="grey" max-width="300" content-class="filter-summary-tooltip">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon class="ml-2" size="20" style="color: #757575; cursor: pointer;" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                                </template>
                                <span>{{ $t('carbonCredit.projectType') }}</span>
                              </v-tooltip>
                            </div>
                            <div class="view-value">{{ getProjectTypeName(projectType) }}</div>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" v-if="projects">
                          <div class="view-block">
                            <div class="d-flex align-center">
                              <label class="view-label">{{ $t('carbonCredit.user.project') }}</label>
                              <v-tooltip top color="grey" max-width="300" content-class="filter-summary-tooltip">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon class="ml-2" size="20" style="color: #757575; cursor: pointer;" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                                </template>
                                <span>{{ $t('carbonCredit.user.project') }}</span>
                              </v-tooltip>
                            </div>
                            <div class="view-value">{{ getProjectName(projects) }}</div>
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                  </v-card>

                  <div class="d-flex mt-5">

                    <!-- Search Field -->
                    <div class="ml-3" style="width: 280px;">
                      <label for="text"> </label>
                      <v-text-field prepend-inner-icon="mdi-magnify" outlined :placeholder="$t('carbonCredit.search')"
                        dense v-model="search" @input="searchQuery" class="shrink"></v-text-field>
                    </div>
                    <!-- Status Dropdown -->
                    <div class="ml-3 d-flex align-center">
                      <span class="mr-2 mb-6 text-center text-body-1 font-weight-bold">{{
                        $t('carbonCredit.user.status') }}</span>
                      <v-select v-model="projectStatus" :items="allStatuses" item-text="name" item-value="value"
                        outlined dense :placeholder="$t('carbonCredit.user.allUsers')" @change="handleStatusChange"
                        style="width: 180px;" class="shrink" clearable></v-select>
                    </div>
                    <v-spacer></v-spacer>
                    <!-- Pagination Info -->
                    <div class="py-1 title">
                      {{ fromUsers }} - {{ toUsers }} {{ $t("of") }} {{ totalUsers }}
                    </div>
                    <!-- Pagination Controls -->
                    <v-btn class="mx-2" fab small outlined color="primary" :disabled="options.page <= 1"
                      @click="pageChange(false)">
                      <v-icon dark>mdi-chevron-left</v-icon>
                    </v-btn>
                    <v-btn class="mx-2" fab small outlined color="primary" :disabled="options.page >= totalPages"
                      @click="pageChange(true)">
                      <v-icon dark>mdi-chevron-right</v-icon>
                    </v-btn>
                    <!-- Customization Menu -->
                    <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" left :min-width="417">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="mx-2" fab small outlined color="primary" v-bind="attrs" v-on="on">
                          <v-icon dark>mdi-cog-outline</v-icon>
                        </v-btn>
                      </template>
                      <v-card width="417">
                        <v-list>
                          <v-list-item>
                            <v-list-item-title>{{ $t("customization") }}</v-list-item-title>
                          </v-list-item>
                          <v-divider></v-divider>
                          <div class="pl-3 pt-2 font-weight-normal">
                            {{ $t("recordsPerPage") }}
                          </div>
                          <v-list-item>
                            <v-slider v-model="itemsPerPageSlider" :tick-labels="itemsPerPageOptions" :max="3"
                              step="1" ticks="always" tick-size="4"></v-slider>
                          </v-list-item>
                          <v-divider class="mt-n3"></v-divider>
                        </v-list>
                        <v-card-text>
                          <v-container fluid>
                            <v-row>
                              <v-col class="mt-n9" cols="6" v-for="header in headersForCustomization" :key="header.value">
                                <v-checkbox v-if="header.text" v-model="selectedHeaders" :label="header.text"
                                  color="primary" :value="header.text" hide-details></v-checkbox>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-layout justify-center>
                          <v-card-actions class="mb-5">
                            <v-spacer></v-spacer>
                            <v-btn outlined color="primary" @click="resetDefault" width="190">
                              {{ $t("restoreDefault") }}
                            </v-btn>
                            <v-btn color="primary" @click="resetTableStructure" width="190">
                              {{ $t("apply") }}
                            </v-btn>
                          </v-card-actions>
                        </v-layout>
                      </v-card>
                    </v-menu>
                    <!-- Export and Print Buttons -->
                    <v-tooltip top color="black" max-width="350">
                      <!-- <template v-slot:activator="{ on, attrs }">
                        <v-btn class="mx-2" fab small outlined color="primary" v-bind="attrs" v-on="on"
                          @click="exportToPDF">
                          <v-img src="/icons/download.svg"></v-img>
                        </v-btn>
                      </template> -->
                      <span>{{ $t("download") }}</span>
                    </v-tooltip>
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="mx-2" fab small outlined color="primary" v-bind="attrs" v-on="on"
                          @click="printPDF">
                          <v-icon dark>mdi-printer</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("print") }}</span>
                    </v-tooltip>
                  </div>
                </template>
                <!-- Individual column templates -->
                 <template v-slot:item.userNameAndId="{ item }">
                   <div class="user-name-and-id">
                     <span class="d-block">{{ item.displayName || '-' }}</span>
                     <span class="d-block">| {{ item.id }}</span>
                   </div>
                 </template>
                 <template v-slot:item.email="{ item }">
                   <span class="text-truncate">{{ item.email || '-' }}</span>
                 </template>
                 <template v-slot:item.userRole="{ item }">
                   <span class="text-truncate">{{ item.userRole || '-' }}</span>
                 </template>
                 <template v-slot:item.organizations="{ item }">
                   <span class="organization-cell">{{ item.organizations || '-' }}</span>
                 </template>
                 <template v-slot:item.userRegistrationDate="{ item }">
                   <span class="text-truncate">{{ item.userRegistrationDate || '-' }}</span>
                 </template>
                 <template v-slot:item.status="{ item }">
                   <div class="d-flex align-center">
                     <v-btn small rounded min-width="120" depressed :class="getStatusClass(item.status)" height="40" class="mr-2">
                       {{ getStatusText(item.status) }}
                     </v-btn>
                     <v-icon v-if="item.status === 'active' && !item.verified" color="warning" small>
                       mdi-alert-triangle
                     </v-icon>
                   </div>
                 </template>
                 <template v-slot:item.warnings="{ item }">
                   <div class="d-flex justify-center align-center" v-if="hasWarnings(item)">
                     <v-tooltip top color="white" max-width="300">
                       <template v-slot:activator="{ on, attrs }">
                         <img 
                           src="@/assets/icons/warning-icon.svg" 
                           alt="Warning" 
                           v-bind="attrs" 
                           v-on="on"
                           style="cursor: pointer; width: 17px; height: 16px;"
                         />
                       </template>
                       <span style="color: #333; white-space: pre-line;">{{ getWarningTooltip(item) }}</span>
                     </v-tooltip>
                   </div>
                 </template>
                 <template v-slot:item.actions="{ item }">
                   <div class="d-flex justify-center">
                     <v-menu location="start">
                       <template v-slot:activator="{ on, attrs }">
                         <v-btn icon v-bind="attrs" v-on="on" small>
                           <v-icon>mdi-dots-vertical</v-icon>
                         </v-btn>
                       </template>
                       <v-list>
                         <v-list-item @click="viewUser(item)">
                           <v-list-item-title>{{ $t("carbonCredit.user.view") }}</v-list-item-title>
                         </v-list-item>
                         <v-list-item @click="toggleUserStatus(item.id)">
                           <v-list-item-title :style="item.active === true ? 'color: red;' : 'color: green;'">
                            {{ item.active === true ? $t("carbonCredit.user.deactivate") : $t("carbonCredit.user.activate") }}
                           </v-list-item-title>
                         </v-list-item>
                         <v-list-item
                           v-if="isUserDataReady && isSuperAdmin"
                           @click="deleteUser(item.id)"
                         >
                           <v-list-item-title style="color: red;">
                             {{ $t("carbonCredit.user.delete") }}
                           </v-list-item-title>
                         </v-list-item>
                       </v-list>
                     </v-menu>
                   </div>
                 </template>
                <template v-slot:footer></template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
    <!-- Confirmation Dialog -->
    <ConfirmationBox 
      :dialog="confirmDeactivateDialog"
      actionType="reject"
      :message="confirmDeactivate.message"
      :confirmData="confirmDeactivate.confirmData"
      :dialogTitle="confirmDeactivate.title"
      :confirmButtonText="confirmDeactivate.confirmBtnText"
      @close="confirmDeactivateDialog = false" 
      @confirm="confirmDeactivateProjectUser" />
    <ConfirmationBox
      :dialog="confirmDeleteDialog"
      actionType="reject"
      :message="confirmDelete.message"
      :confirmData="confirmDelete.confirmData"
      :dialogTitle="confirmDelete.title"
      :confirmButtonText="confirmDelete.confirmBtnText"
      @close="confirmDeleteDialog = false"
      @confirm="confirmUnlinkCarbonCreditUser"
    />
  </div>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import download from "@/mixins/DownloadMixin";
import getPermittedActions from "@/mixins/GetPermittedActions";
import DateMixin from "@/mixins/DateMixin";
import CarbonCreditService from "@/_services/CarbonCreditService";
import { getCountries } from "country-state-picker";
import html2pdf from "html2pdf.js";
import printJS from "print-js";
import ConfirmationBox from "./components/ConfirmationBox";
import moment from "moment";
import RoleMixin from "@/mixins/RoleMixin";
import { mapGetters } from "vuex";
import UserService from "@/_services/UserService";
export default {
components: {
  ConfirmationBox,
},
created() {
  this.getUsers();
  this.getOrganizations();
},
async mounted() {
  this.tableHeaders = this.headers;
  this.selectedHeaders = this.allSelectedHeaders;
},
watch: {
  projectType(newVal, oldVal) {
    if (newVal !== oldVal) {
      // Let filterData handle the project type change
      this.filterData();
    }
  },
},
computed: {
  ...mapGetters(["getUser", "getUserRoles"]),
  isOwner() {
    return this.getCurrentRoles && Array.isArray(this.getCurrentRoles) && this.getCurrentRoles.some((x) => ["owner"].includes(x));
  },
  isSuperAdmin() {
    try {
      const userRoles = this.getUserRoles;
      const currentRoles = this.getCurrentRoles;
      const isSuperFromVuex = userRoles && Array.isArray(userRoles) && userRoles.some((role) => role === "super_admin");
      const isSuperFromLocal = currentRoles && Array.isArray(currentRoles) && currentRoles.some((role) => role === "super_admin");
      return isSuperFromVuex || isSuperFromLocal;
    } catch (error) {
      return false;
    }
  },
  isUserDataReady() {
    const userFromVuex = this.getUser;
    const rolesFromVuex = this.getUserRoles;
    const rolesFromLocal = this.getCurrentRoles;
    return (userFromVuex && rolesFromVuex && Array.isArray(rolesFromVuex)) ||
           (rolesFromLocal && Array.isArray(rolesFromLocal));
  },
  totalPages() {
    return parseInt(Math.ceil(this.totalUsers / this.options.limit));
  },
  safeProjectList() {
    return Array.isArray(this.projectList) ? this.projectList : [];
  },
  safeOrganizationList() {
    return Array.isArray(this.organizationList) ? this.organizationList : [];
  },
  hasActiveFilters() {
    return this.projectType || this.organizations || this.projects || this.projectStatus;
  },
  displayTableHeaders() {
    if (!this.tableHeaders || !this.tableHeaders.length) return this.tableHeaders || [];
    if (this.isUserDataReady && this.isSuperAdmin) return this.tableHeaders;
    return this.tableHeaders.filter((h) => h.value !== 'organizations');
  },
  headersForCustomization() {
    if (this.isUserDataReady && this.isSuperAdmin) return this.headers;
    return this.headers.filter((h) => h.value !== 'organizations');
  },
  filteredHeaders() {
    return this.headers.filter(header => this.selectedHeaders.includes(header.value));
  },
},
data() {
  return {
    debounceTimer: null,
    fromUsers: 0,
    toUsers: 0,
    search: "",
    projectTypeList: [
      { name: this.$t("carbonCredit.forestry"), value: "forestry" },
      { name: this.$t("carbonCredit.agroForestry"), value: "agroforestry" },
      { name: this.$t("carbonCredit.regenerativeAgriculture"), value: "regenerative_agriculture" },
    ],
    projectType: "",
    previousProjectType: "",
    organizationList: [],
    organizations: "",
    previousOrganizations: "",
    projectList: [],
    countryModel: "",
    projectStatus: '',
    countries: [...getCountries()],
    loading: false,
    selectedItem: false,
    options: {
      limit: 10,
      page: 1,
    },
    headers: [
      {
        text: this.$t("carbonCredit.user.userNameAndId"),
        align: "start",
        value: "userNameAndId",
        class: "black--text",
        sortable: true,
      },
      {
        text: this.$t("carbonCredit.user.email"),
        align: "start",
        value: "email",
        class: "black--text",
        sortable: true,
      },
      {
        text: this.$t("carbonCredit.user.userRole"),
        align: "start",
        value: "userRole",
        class: "black--text",
        sortable: true,
      },
      {
        text: this.$t("carbonCredit.user.organizations"),
        align: "start",
        value: "organizations",
        class: "black--text",
        sortable: true,
        width: "180px",
      },
      {
        text: this.$t("carbonCredit.user.userRegistrationDate"),
        align: "start",
        value: "userRegistrationDate",
        class: "black--text",
        sortable: true,
      },
      {
        text: this.$t("carbonCredit.user.status"),
        align: "start",
        value: "status",
        class: "black--text",
        sortable: true,
      },
      {
        text: "",
        align: "center",
        value: "warnings",
        class: "black--text",
        sortable: false,
        width: "60px",
      },
      {
        text: this.$t("Actions"),
        align: "center",
        value: "actions",
        class: "black--text",
        sortable: false,
      },
    ],
    allSelectedHeaders: [
      this.$t("carbonCredit.user.userNameAndId"),
      this.$t("carbonCredit.user.email"),
      this.$t("carbonCredit.user.userRole"),
      this.$t("carbonCredit.user.organizations"),
      this.$t("carbonCredit.user.userRegistrationDate"),
      this.$t("carbonCredit.user.status"),
      "",
      this.$t("Actions"),
    ],
    menu: false,
    breadcrumbs: [
      {
        text: this.$t("carbonCredit.dashboard"),
        disabled: false,
        href: "/dashboard",
        exact: true,
      },
      {
        text: this.$t("carbonCredit.title"),
        disabled: false,
        href: "/carbon-credit/projects",
      },
      {
        text: this.$t("carbonCredit.projects"),
        disabled: true,
        href: "breadcrumbs_link_2",
        exact: true,
      },
    ],
    users: [],
    totalUsers: 0,
    itemsPerPageOptions: [5, 10, 25, 50],
    itemsPerPageSlider: 1,
    selectedHeaders: [],
    tableHeaders: [],
    showActionsColumn: true,
    hideOnPrint: false,
    confirmDeactivateDialog: false,
    confirmDeactivate: {
      title: "",
      message: "",
      confirmBtnText: "",
      cancelBtnText: this.$t("cancel"),
      confirmData: {},
    },
    confirmDeleteDialog: false,
    confirmDelete: {
      title: "",
      message: "",
      confirmBtnText: "",
      cancelBtnText: this.$t("cancel"),
      confirmData: {},
    },
    allStatuses: [
      { name: this.$t("carbonCredit.user.allUsers"), value: "" },
      { name: this.$t("carbonCredit.user.active"), value: "active" },
      { name: this.$t("carbonCredit.user.deactivated"), value: "deactivated" },
    ],
    customizeMenu: false,
    customizeMenuAll: false,
  };
},
methods: {

  async getUsers() {
    this.startLoading();
    try {
      const params = {
        page: this.options.page,
        limit: this.options.limit,
        search: this.search,
        organization: this.isSuperAdmin ? this.organizations : (this.getUser?.user_organization?.id ?? this.organizations),
        projectType: this.projectType,
        project: this.projects,
      };

      if (this.projectStatus === 'active') {
        params.active = 1;
      } else if (this.projectStatus === 'deactivated') {
        params.active = 0;
      }

      const response = await CarbonCreditService.getCarbonCreditUsers(params);

      // Handle the API response structure correctly
      const responseData = response.data || response;
      const usersData = responseData.rows || responseData.data || [];
      const totalCount = responseData.count || 0;

      // Ensure usersData is an array
      if (!Array.isArray(usersData)) {
        this.users = [];
        this.totalUsers = 0;
        this.fromUsers = 0;
        this.toUsers = 0;
        return;
      }

      // Map the API response to match table structure
      this.users = usersData.map(user => {
        try {
          const agreementSubmissionDate = this.getAgreementSubmissionDate(user);
          const displayName = user.fullName || [user.firstName, user.middleName, user.lastName].filter(Boolean).join(' ').trim() || 'N/A';
          return {
            id: user.id,
            displayName,
            userNameAndId: `${displayName} | ${user.id}`,
            email: user.email || 'N/A',
            userRole: this.getUserRole(user.userType, user.registrationUserType),
            organizations: this.getOrganizationName(user.organization) || 'N/A',
            userRegistrationDate: agreementSubmissionDate ? this.getUserRegistrationDateFormat(agreementSubmissionDate) : 'N/A',
            status: user.active ? 'active' : 'deactivated',
            // Additional fields for actions and warnings
            verified: user.verified,
            active: user.active,
            createdAt: user.createdAt,
            updatedAt: user.updatedAt,
            // Farm data for warning checks
            farms: user.farms || [],
            firstName: user.firstName,
            lastName: user.lastName,
            mobile: user.mobile,
            countryId: user.countryId
          };
        } catch (error) {
          console.error('Error mapping user:', user, error);
          return {
            id: user.id || 'N/A',
            displayName: 'N/A',
            userNameAndId: 'N/A',
            email: 'N/A',
            userRole: 'N/A',
            organizations: 'N/A',
            userRegistrationDate: 'N/A',
            status: 'N/A',
            verified: false,
            active: false,
            createdAt: null,
            updatedAt: null,
            farms: [],
            firstName: null,
            lastName: null,
            mobile: null,
            countryId: null
          };
        }
      });

      this.totalUsers = totalCount;
      this.fromUsers = totalCount > 0 ? (this.options.page - 1) * this.options.limit + 1 : 0;
      this.toUsers = Math.min(this.options.page * this.options.limit, totalCount);

    } catch (error) {
      this.users = [];
      this.totalUsers = 0;
      this.fromUsers = 0;
      this.toUsers = 0;
    } finally {
      this.stopLoading();
    }
  },
  async getOrganizations() {
    try {
      // Use searchOrganizations to get all organizations (not just the current user's org)
      const response = await CarbonCreditService.searchOrganizations({});

      // Handle the response structure
      if (response.success && response.data) {
        // Filter to include only parent organizations (exclude sub-organizations)
        const parentOrgs = response.data
          .filter(org => !org.isSubOrganization && !org.parentId)
          .map(org => ({
            id: org.id,
            name: org.name,
            code: org.code,
            country: org.country,
            recordId: org.recordId
          }));
        this.organizationList = parentOrgs;
      } else {
        this.organizationList = [];
      }
    } catch (error) {
      console.error('Error fetching organizations:', error);
      this.organizationList = [];
    }
  },
  async getProjects(projectType) {
    try {
      const params = { type: projectType };
      if (this.organizations) {
        params.organization = this.organizations;
      }
      const response = await CarbonCreditService.getCarbonCreditProjects(params);

      // Ensure projectList is always an array
      const projectsData = response.data?.rows || response.data || [];
      this.projectList = Array.isArray(projectsData) ? projectsData : [];

    } catch (error) {
      this.projectList = [];
    }
  },
  async resetDefault() {
    this.tableHeaders = this.headers;
    this.selectedHeaders = this.allSelectedHeaders;
    this.options.limit = this.itemsPerPageOptions[this.itemsPerPageSlider];
    this.menu = false;
    await this.getUsers()
  },
  async resetTableStructure() {
    this.tableHeaders = this.headers.filter((header) =>
      this.selectedHeaders.includes(header.text)
    );
    this.options.limit = this.itemsPerPageOptions[
      this.itemsPerPageSlider
    ];
    await this.getUsers();
    (this.customizeMenu = false), (this.customizeMenuAll = false);
  },
  getDateFormat(date) {
    return moment(date).format("DD/MM/YYYY");
  },
  handleCreateProject() {
    this.$router.push({ name: "createProject" });
  },
  handleProjectSettings() {
    this.$router.push({ name: "projectSettings" });
  },
  filterData() {
    this.options.page = 1;

    // Handle organization changes: refetch projects for selected org and clear project selection
    if (this.organizations !== this.previousOrganizations) {
      this.previousOrganizations = this.organizations;
      this.projects = '';
      if (this.projectType) {
        this.getProjects(this.projectType);
      } else {
        this.projectList = [];
      }
    }

    // Handle project type changes
    if (this.projectType !== this.previousProjectType) {
      this.previousProjectType = this.projectType;
      this.projects = '';

      if (this.projectType) {
        this.getProjects(this.projectType);
      } else {
        this.projectList = [];
      }
    }
    this.getUsers();
  },
  handleStatusChange() {
    this.options.page = 1;
    this.getUsers();
  },
  searchQuery() {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.options.page = 1;
      this.getUsers();
    }, 500);
  },
  async exportToPDF() {
    const requestParams = {
      page: this.options.page,
      limit: this.options.limit,
      search: this.search,
      country: this.countryModel,
      status: this.projectStatus,
    };
    const querys = new URLSearchParams(requestParams).toString();
    const token = this.$store.state.auth.token;
    this.startLoading();
    const url = process.env.VUE_APP_API_BASE_URL || "https://api.example.com";
    this.downloadSourceFileWithToken(
      `${url}/projects/pdf?${querys}`,
      "application/pdf",
      token,
      "projects.pdf"
    )
      .then(() => {
        this.stopLoading();
      })
      .catch(() => {
        this.stopLoading();
      });
  },
  async printPDF() {
    this.showActionsColumn = false;
    this.hideOnPrint = true;
    await this.$nextTick(); // Wait for DOM to update
    // Remove action column from the DOM for printing
    const table = document.querySelector('.v-data-table__wrapper table');
    let removedHeader, removedCells = [];
    if (table) {
      // Remove the last th (action column header)
      const headerRow = table.querySelector('thead tr');
      if (headerRow && headerRow.children.length > 0) {
        removedHeader = headerRow.removeChild(headerRow.lastElementChild);
      }
      // Remove the last td in each body row (action column cells)
      const bodyRows = table.querySelectorAll('tbody tr');
      bodyRows.forEach(row => {
        if (row.children.length > 0) {
          removedCells.push(row.removeChild(row.lastElementChild));
        }
      });
    }
    const element = document.querySelector(".v-data-table__wrapper");
    let opt = {
      margin: 1,
      filename: "CarbonCreditUsers.pdf",
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
    };
    let worker = await html2pdf()
      .set(opt)
      .from(element)
      .toCanvas()
      .outputPdf("blob", "CarbonCreditUsers.pdf");
    let file = new File([worker], "CarbonCreditUsers.pdf", { type: "application/pdf" });
    var pdfUrl = await URL.createObjectURL(file);
    await printJS({ printable: `${pdfUrl}`, type: "pdf", showModal: true });
    // Restore the action column after printing
    if (table && removedHeader) {
      const headerRow = table.querySelector('thead tr');
      if (headerRow) {
        headerRow.appendChild(removedHeader);
      }
      const bodyRows = table.querySelectorAll('tbody tr');
      bodyRows.forEach((row, idx) => {
        if (removedCells[idx]) {
          row.appendChild(removedCells[idx]);
        }
      });
    }
    this.showActionsColumn = true;
    this.hideOnPrint = false;
    await this.$nextTick(); // Ensure DOM is updated after restoring
  },
  selectItem(item) {
    this.selectedItem = item;
  },
  pageChange(next) {
    if (next) this.options.page += 1;
    else this.options.page -= 1;
    this.getUsers();
  },  
  toggleUserStatus(id) {
    // Find the user to get their current status
    const user = this.users.find(user => user.id === id);
    if (!user) {
      console.error('User not found:', id);
      return;
    }

    // Set the confirmation dialog content based on user's current status
    this.confirmDeactivate.title = user.active 
      ? this.$t("carbonCredit.user.deactivateUser") 
      : this.$t("carbonCredit.user.activateUser");
    
    this.confirmDeactivate.message = user.active 
      ? this.$t("carbonCredit.user.deactivateConfirmation") 
      : this.$t("carbonCredit.user.activateConfirmation");
    
    this.confirmDeactivate.confirmBtnText = user.active 
      ? this.$t("carbonCredit.user.deactivate") 
      : this.$t("carbonCredit.user.activate");

    this.confirmDeactivate.confirmData = { id, active: user.active };
    this.confirmDeactivateDialog = true;
  },
  async confirmDeactivateProjectUser(confirmData) {
    this.confirmDeactivateDialog = false;
    try {
      const response = confirmData.active
        ? await CarbonCreditService.deleteCarbonCreditUser(confirmData.id)
        : await UserService.toggleUserStatus(confirmData.id);

      if (response && response.success) {
        this.getUsers();
        const isActivating = !confirmData.active;
        this.$notify({
          title: isActivating 
            ? this.$t("carbonCredit.user.activatedSuccessfully") 
            : this.$t("carbonCredit.user.deactivatedSuccessfully"),
          type: "success",
        });
      } else {
        throw new Error('API call failed');
      }
    } catch (error) {
      console.error('Error toggling user status:', error);
      const isActivating = !confirmData.active;
      this.$notify({
        title: isActivating 
          ? this.$t("carbonCredit.user.activationFailed") 
          : this.$t("carbonCredit.user.deactivationFailed"),
        type: "error",
      });
    }
  },
  deleteUser(id) {
    const user = this.users.find((u) => u.id === id);
    if (!user) {
      console.error("User not found:", id);
      return;
    }
    this.confirmDelete.title = this.$t("carbonCredit.user.deleteUser");
    this.confirmDelete.message = this.$t("carbonCredit.user.deleteConfirmation");
    this.confirmDelete.confirmBtnText = this.$t("carbonCredit.user.delete");
    this.confirmDelete.confirmData = { id };
    this.confirmDeleteDialog = true;
  },
  async confirmUnlinkCarbonCreditUser(confirmData) {
    this.confirmDeleteDialog = false;
    try {
      const response = await CarbonCreditService.unlinkCarbonCreditUser(
        confirmData.id
      );
      if (response && response.success) {
        this.getUsers();
        this.$notify({
          title: response.message || this.$t("carbonCredit.user.deletedSuccessfully"),
          type: "success",
        });
      } else {
        throw new Error("API call failed");
      }
    } catch (error) {
      console.error("Error unlinking carbon credit user:", error);
      const apiMessage = error?.data?.message || error?.response?.data?.message;
      this.$notify({
        title: apiMessage || this.$t("carbonCredit.user.deleteFailed"),
        type: "error",
      });
    }
  },
  viewUser(item) {
    this.$router.push({ name: "userDetails", params: { id: item.id } });
  },
  getStatusText(status) {
    switch (status) {
      case 'active':
        return this.$t('carbonCredit.user.active');
      case 'pending':
        return this.$t('carbonCredit.user.pending');
      case 'deactivated':
        return this.$t('carbonCredit.user.deactivated');
      default:
        return status || 'N/A';
    }
  },
  getOrganizationName(orgId) {
    if (!orgId) return null;
    if (!Array.isArray(this.organizationList)) {
      return `Org ${orgId}`;
    }

    // Try to find organization by id or code
    const org = this.organizationList.find(org =>
      org.id === orgId ||
      org.code === orgId ||
      org.recordId === orgId
    );

    if (org) {
      return org.name || `Org ${orgId}`;
    }

    return `Org ${orgId}`;
  },
  getUserRole(userType, registrationUserType) {
    if (userType === 'offline') {
      return registrationUserType === 'corporate' ? 'Technician' : 'Farmer';
    }
    return userType === 'technician' ? 'Technician' : 'Farmer';
  },
  getUserRegistrationDateFormat(date) {
    return moment(date).format("DD-MMM-YYYY").toUpperCase();
  },
  getAgreementSubmissionDate(user) {
    if (!user || !user.farms || !Array.isArray(user.farms)) return null;
    let latest = null;
    for (const farm of user.farms) {
      const projectFarms = farm.projectFarms || [];
      for (const pf of projectFarms) {
        const d = pf.created_at || pf.createdAt;
        if (d && (!latest || new Date(d) > new Date(latest))) latest = d;
      }
    }
    return latest;
  },
  getProjectTypeName(value) {
    const projectType = this.projectTypeList.find(type => type.value === value);
    return projectType ? projectType.name : value;
  },
  getProjectName(projectId) {
    const project = this.safeProjectList.find(project => project.id === projectId);
    return project ? project.project_title : `Project ${projectId}`;
  },
  getStatusClass(status) {
    switch (status) {
      case 'active':
        return 'green-button';
      case 'pending':
        return 'gray-button';
      case 'deactivated':
        return 'red-button';
      default:
        return 'gray-button';
    }
  },
  handleRegisterProject() {
    this.$router.push('/carbon-credit/projects/register');
  },
  hasWarnings(item) {
    // Check for mandatory information missing
    const hasMandatoryInfoMissing = this.checkMandatoryInfoMissing(item);
    
    // Check for farm request pending
    const hasFarmRequestPending = this.checkFarmRequestPending(item);
    
    return hasMandatoryInfoMissing || hasFarmRequestPending;
  },
  checkMandatoryInfoMissing(item) {
    // Check if farms have mandatory project title
    if (item.farms && Array.isArray(item.farms) && item.farms.length > 0) {
      for (const farm of item.farms) {
        // Check if farm is associated with a project and has project title
        if (farm.projectFarms && Array.isArray(farm.projectFarms) && farm.projectFarms.length > 0) {
          for (const projectFarm of farm.projectFarms) {
            // Check if project has a title
            if (projectFarm.project && !projectFarm.project.project_title) {
              return true;
            }
          }
        }
      }
    }
    
    return false;
  },
  checkFarmRequestPending(item) {
    // Check if any farm has pending request status
    if (item.farms && Array.isArray(item.farms) && item.farms.length > 0) {
      for (const farm of item.farms) {
        if (farm.projectFarms && Array.isArray(farm.projectFarms) && farm.projectFarms.length > 0) {
          for (const projectFarm of farm.projectFarms) {
            const status = projectFarm.status;
            // Statuses that indicate pending: 'in_review', 'in_progress'
            if (status === 'in_review' || status === 'in_progress') {
              return true;
            }
          }
        }
      }
    }
    
    return false;
  },
  getWarningTooltip(item) {
    const warnings = [];
    
    // Check mandatory info missing
    if (this.checkMandatoryInfoMissing(item)) {
      warnings.push(this.$t('carbonCredit.user.mandatoryInfoMissing'));
    }
    
    // Check farm request pending
    if (this.checkFarmRequestPending(item)) {
      warnings.push(this.$t('carbonCredit.user.farmRequestPending'));
    }
    
    return warnings.join('\n');
  },
  filterOrganizations(item, queryText) {
    // Custom filter function for organization search in autocomplete
    if (!queryText) return true;
    const searchText = queryText.toLowerCase();
    const organizationName = (item.name || '').toLowerCase();
    return organizationName.includes(searchText);
  },
  async exportAs(type) {
    if (type === 'csv') {
      this.startLoading();
      try {
        await CarbonCreditService.exportProjectsAsCSV({
          page: this.options.page,
          limit: this.options.limit,
          search: this.search,
          country: this.countryModel,
          status: this.projectStatus,
        });
      } catch (err) {
        this.$notify({
          text: this.$t('carbonCredit.exportFailed'),
          type: 'error',
        });
      } finally {
        this.stopLoading();
      }
    } else if (type === 'excel') {
      this.startLoading();
      try {
        await CarbonCreditService.exportProjectsAsExcel({
          page: this.options.page,
          limit: this.options.limit,
          search: this.search,
          country: this.countryModel,
          status: this.projectStatus,
        });
      } catch (err) {
        this.$notify({
          text: this.$t('carbonCredit.exportFailed'),
          type: 'error',
        });
      } finally {
        this.stopLoading();
      }
    } else if (type === 'pdf') {
      // TODO: Implement PDF export if needed
    }
  },
},
mixins: [loadingMixin, download, getPermittedActions, DateMixin, RoleMixin],
};
</script>

<style lang="scss" scoped>
.user-name-and-id {
  line-height: 1.4;
}

.organization-cell {
  display: block;
  max-width: 180px;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.carbon-credit-users-header {
  flex-wrap: nowrap;
  align-items: center;
}

.carbon-credit-users-title {
  white-space: nowrap;
  flex-shrink: 0;
  margin: 0 !important;
  line-height: 40px;
  height: 40px;
  display: flex;
  align-items: center;
}

.carbon-credit-filter-select {
  width: 200px;
  max-width: 200px;
  flex-shrink: 0;
}

.carbon-credit-filter-select-type {
  width: 160px;
  max-width: 160px;
}

.carbon-credit-filter-select-project {
  width: 260px;
  max-width: 260px;
}

/* Keep header row controls same height and vertically aligned */
.carbon-credit-users-header ::v-deep .v-input {
  padding-top: 0;
  margin-top: 0;
  margin-bottom: 0;
}

.carbon-credit-users-header ::v-deep .v-input__control {
  min-height: 40px;
}

.carbon-credit-users-header ::v-deep .v-btn {
  height: 40px;
}

.custom-btn {
background-color: #FFFFFF !important;
color: #00BD73 !important;
border: 2px solid #00BD73 !important;
box-shadow: none !important;

&:hover {
  background-color: #e0e0e0 !important;
}
}

.green-button {
background-color: #c1ffe7 !important;
border: 2px solid #00bd73 !important;
color: #489e16 !important;
}

.red-button {
background-color: #fdecea !important;
border: 2px solid #f03737 !important;
color: #f03737 !important;
}

.gray-button {
background-color: #e8e8e8 !important;
border: 2px solid #000000 !important;
color: #000000 !important;
}

::v-deep .v-data-table-header span {
text-transform: uppercase !important;
color: black;
}

/* Hide the action column when printing */
@media print {
.action-col {
  display: none !important;
}
}

/* Filter summary cards – same design as UserDetails view-block */
.view-block {
  background-color: #E5F8F1;
  padding: 1rem;
  border-radius: 6px;
  margin-bottom: 1rem;
}

.view-label {
  font-size: 16px;
  color: #555;
  margin-bottom: 4px;
  display: block;
  font-weight: 300;
}

.view-value {
  font-weight: bold;
  font-size: 1rem;
  color: #333;
}

.filter-card {
background-color: #E5F8F1 !important;
border: 1px solid #b8ead5 !important;
border-radius: 8px !important;
transition: all 0.3s ease;

&:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1) !important;
}

.v-card__text {
  padding: 16px !important;
}

.text-caption {
  font-size: 12px !important;
  font-weight: 500 !important;
  color: #64748b !important;
}

.text-h6 {
  font-size: 16px !important;
  font-weight: 600 !important;
  color: #1e293b !important;
  line-height: 1.4 !important;
}
}
</style>
<style lang="scss">
/* Tooltip outline – not scoped so it applies to portaled tooltip content */
.filter-summary-tooltip {
  border: 1px solid #9e9e9e !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style> 